import { get, isArray, isNil } from 'es-toolkit/compat';

// only the array form returns a string; a plain dataPath returns the raw value, which may be
// nil — callers must handle that themselves
export function getCellInfo(dataRow: object, dataPath: string | string[]): unknown {
  if (isArray(dataPath)) {
    // keep 0/false — only nil and empty string carry no displayable content
    return dataPath
      .map(item => get(dataRow, item))
      .filter(value => !isNil(value) && value !== '')
      .join(' ');
  }

  return get(dataRow, dataPath);
}
